export const LEARNERS_PER_PAGE = 10;
